import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumber } from 'lib/common/format-phone-number';
import { imageCdnAsset } from 'lib/common/url-helpers';

const INPUT_CHANGE_TIMEOUT = 500;

const propTypes = {
  sendContactInquiry: PropTypes.func.isRequired,
};

class GetInTouch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
    };

    this.updateEmail = this.updateEmail.bind(this);
    this.updateName = this.updateName.bind(this);
    this.onPhoneNumberFieldChange = this.onPhoneNumberFieldChange.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  updateEmail() {
    this.setState({ email: this.email.value });
  }

  updateName() {
    this.setState({ fullName: this.fullName.value });
  }

  updateMessage() {
    this.setState({ message: this.message.value });
  }

  onPhoneNumberFieldChange(e) {
    clearTimeout(this.phoneNumberChangeTimeout);
    const { target } = e;
    let newNumber = target.value.replace(/\D/g, '');
    const maxLength = newNumber[0] === '1' ? 11 : 10;

    // Don't let user enter more numbaZ
    newNumber = newNumber.substring(0, maxLength);
    this.setState({ phone: newNumber });
    this.phoneNumberChangeTimeout = setTimeout(this.onPhoneNumberChange, INPUT_CHANGE_TIMEOUT);
  }

  onSubmit() {
    this.props.sendContactInquiry({
      fullName: this.state.fullName,
      email: this.state.email,
      phone: this.state.phone,
      message: this.state.message,
    });
    this.setState({ submitted: true });
  }

  render() {
    const { submitted, phone } = this.state;
    const submittedClassNames = (!submitted) ? 'margin-top-120' : '';

    return (
      <div className="contact-us-learn-more container margin-top-sm-40 margin-top-xs-20 margin-bottom-sm-100">
        <div className="row">
          <div className={`hidden-xs col-sm-5 col-gutter-sm-0 ${submittedClassNames}`}>
            <img src={imageCdnAsset('/images/press/contact-img@2x.png')} alt="Contact Us" />
          </div>
          <div className="col-sm-7 col-sm-pull-1 col-xs-12 col-gutter-xs-30 background-color-transparent-light-grey margin-top-40">
            {submitted &&
              <div className="padding-top-sm-50 padding-left-sm-100 padding-top-xs-20">
                <div className="text-size-sm-42 text-size-xs-28 text-weight-black text-color-dark-slate line-height-full">
                  <span className="text-color-blue">THANKS</span> FOR CONTACTING US!
                </div>
                <div className="text-color-dark-slate text-size-sm-28 text-size-xs-18 text-weight-book margin-top-sm-15 margin-top-xs-20 margin-bottom-40">
                  We will contact you shortly.
                </div>
              </div>
            }
            {!submitted &&
            <div className="padding-top-sm-50 padding-left-sm-100 padding-top-xs-20">
              <div className="text-size-sm-42 text-size-xs-28 text-weight-black text-color-dark-slate line-height-full">
                GET IN <span className="text-color-blue">TOUCH</span>
              </div>
              <div className="text-color-dark-slate text-size-sm-28 text-size-xs-18 font-family-georgia margin-top-sm-15 margin-top-xs-20">
                Please direct all press inquiries to Christie Dooley, Communications Lead.
              </div>
              <form onSubmit={this.onSubmit}>
                <div className="form-group margin-top-20 padding-right-sm-80">
                  <label htmlFor="email" className="text-size-sm-14 text-weight-book required-field">Email (Required)</label>
                  <input
                    className="form-control form-control-white"
                    placeholder="Your Email Address"
                    type="email"
                    id="email"
                    required
                    onBlur={this.updateEmail}
                    ref={(email) => { this.email = email; }}
                  />
                </div>
                <div className="form-group margin-top-20 padding-right-sm-80">
                  <label className="text-size-sm-14 text-weight-book required-field" htmlFor="fullName">Full Name</label>
                  <input
                    className="form-control form-control-white"
                    placeholder="Your Name"
                    type="text"
                    id="fullName"
                    required
                    onBlur={this.updateName}
                    ref={(fullName) => { this.fullName = fullName; }}
                  />
                </div>
                <div className="form-group margin-top-20 padding-right-sm-80">
                  <label className="text-size-sm-14" htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="form-control form-control-white"
                    placeholder="---  ---  ----"
                    value={formatPhoneNumber(phone)}
                    onChange={this.onPhoneNumberFieldChange}
                    ref={(phoneNumber) => { this.phone = phoneNumber; }}
                  />
                </div>
                <div className="form-group margin-top-20 padding-right-sm-80">
                  <label className="text-size-sm-14" htmlFor="message">Message</label>
                  <textarea
                    rows="5"
                    type="textarea"
                    id="message"
                    name="message"
                    className="form-control form-control-white"
                    placeholder="Your Message"
                    onBlur={this.updateMessage}
                    ref={(message) => { this.message = message; }}
                  />
                </div>
                <input
                  type="submit"
                  className="pw-btn pw-btn-green text-weight-book text-size-xs-16 margin-top-20 margin-bottom-20 padding-vertical-15 padding-horizontal-40"
                  value="SEND"
                />
              </form>
            </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

GetInTouch.propTypes = propTypes;

export default GetInTouch;
